import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getById } from "@insite/client-framework/Store/Data/DataState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import PriceRequestModal from "@preferredMedical/Widgets/ProductDetails/PriceRequestModal";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState, context: HasProduct) => ({
    session: state.context.session,
    productState: getById(state.data.products, context.product.id).value,
    emailRecipients: getSettingsCollection(state).priceRequestEmailRecipients as string,
    title: getSettingsCollection(state).priceRequestNdcTitle as string,
    description: getSettingsCollection(state).priceRequestNdcDescription as string,
    requiredFieldsLabel: getSettingsCollection(state).priceRequestNdcRequiredFieldsLabel as string,
});

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const cssWrapper = {
    css: css`
        margin-top: 30px;
        text-align: center;
    `,
};

const PriceRequestButton: React.FC<Props> = ({
    productState,
    emailRecipients,
    title,
    description,
    requiredFieldsLabel,
}) => {
    if (!productState || !productState.properties || productState.properties.priceRequestEnabled?.toLowerCase() === "false") {
        return null;
    }

    return (
        <StyledWrapper {...cssWrapper}>
            <PriceRequestModal
                emailRecipients={emailRecipients}
                title={title}
                description={description}
                requiredFieldsLabel={requiredFieldsLabel}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(PriceRequestButton)),
    definition: {
        displayName: "Price Request",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;